// path: frontend/src/config.ts
const viteEnv = (import.meta as any).env || {};

// Prefer the newest variable name, keep backward-compat keys
const envBase = (
  viteEnv.VITE_API_BASE_URL ||
  viteEnv.VITE_API_BASE ||
  viteEnv.VITE_API_URL ||
  ""
).toString().trim();

// Current origin (browser), or sensible default when SSR/tools run it
const origin =
  typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.hostname}${window.location.port ? ":" + window.location.port : ""
    }`
    : "http://127.0.0.1:8000";

// In dev (vite serve 5173) or preview (5174), default backend is FastAPI on 8000
const isDevLikePort =
  typeof window !== "undefined" &&
  (window.location.port === "5173" || window.location.port === "5174");

const devDefault = isDevLikePort ? "http://127.0.0.1:8000" : origin;

// Trim trailing slashes for consistency
export const API_BASE_URL = (envBase || devDefault).replace(/\/+$/, "");

// Standard Vite flag
export const isDev = viteEnv.MODE !== "production";

// Helpful console note in the browser only
if (typeof window !== "undefined") {
  const source = envBase
    ? "env(VITE_API_BASE_URL|VITE_API_BASE|VITE_API_URL)"
    : devDefault !== origin
      ? "dev-default(8000)"
      : "origin";
  // eslint-disable-next-line no-console
  console.info(`🌐 API Base URL: ${API_BASE_URL} (source: ${source})`);
}
